import { z } from "zod";
import { emailAdressValidator } from "../../../Utils/stringUtls";

// Input Form Validation Schema
export const validationSchema = z.object({
  email: z
    .string()
    .min(1, { message: "Email address is required" })
    .refine((val) => emailAdressValidator(val), "Invalid Email address"),
});
